const email = {
  sendEmail: "Отправить письмо",
  sendBtn: "Отправить",
  sent: "Письмо отправлено!",
  to: "Кому",
  from: "От",
  subject: "Тема",
  template: "Шаблон",
  noTemplate: "— Без шаблона —",
  variables: "Переменные",
  sendFrom: "Отправить от",
  cancel: "Отмена",
  showCcBcc: "CC/BCC",
  hideCcBcc: "Скрыть CC/BCC",
  toPlaceholder: "email@example.com (через запятую)",
  recipientRequired: "Укажите получателя",
  subjectRequired: "Укажите тему",
  status: "Статус",
  sentAt: "Отправлено",
  opens: "Открытия",
  clicks: "Клики",
  firstOpened: "Первое открытие",
  clickedLinks: "Нажатые ссылки",
  htmlPreview: "Предпросмотр HTML",
  bounceReason: "Причина отклонения",
  errorMessage: "Ошибка",
  totalSent: "Отправлено",
  opened: "Открыто",
  clicked: "Кликнуто",
  bounced: "Отклонено",
  openRate: "Процент открытий",
  clickRate: "Процент кликов",
  noEmailsSent: "Пока нет отправленных писем",
  emails: "Почта",
} as const;
export default email;
